module.exports = __webpack_public_path__ + "static/22-4a6bb8985e465e633613d4709fa0f243.png";